import React, { useEffect, useState } from 'react'
import './styles.scss'
import { Toast } from 'react-bootstrap'

import {
  GET_ALL_UNREAD_NOTIFICATIONS,
  NotificationListResponse
} from 'share/queries/notifications'
import { useLazyQuery, useMutation } from '@apollo/client'
import {
  Notification,
  NotificationDisplayType
} from 'share/domain/notification'
import { useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import {
  MarkAsDeliveredResponse,
  MARK_AS_DELIVERED
} from 'share/mutations/notifications'
import { pollNotificationsEnabled } from 'AppSettings'
import { AccountCreationStep } from 'share/utils/utils'

function ToastNotification(): JSX.Element {
  const authentication = useSelector((state: RootState) => state.authentication)
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [interval, setIntervalTimer] = useState<NodeJS.Timeout | null>(null)
  const [getAllNotifications, { data }] =
    useLazyQuery<NotificationListResponse>(GET_ALL_UNREAD_NOTIFICATIONS, {
      fetchPolicy: 'network-only'
    })
  const [notificationMarkAsDelivered] =
    useMutation<MarkAsDeliveredResponse>(MARK_AS_DELIVERED)

  function setUpNotifications() {
    if (
      authentication.isAuthenticated &&
      authentication.accessToken &&
      authentication.account &&
      authentication.account.accountCreationStep ===
        AccountCreationStep.CompletedAllSteps
    ) {
      if (data) {
        setNotifications(
          data.notifications.get.filter((notif) => notif.delivered != true)
        )
      } else {
        if (!interval) {
          setIntervalTimer(
            setInterval(() => {
              getAllNotifications({
                variables: { read: false }
              })
            }, 15000)
          )
        }
      }
    } else {
      if (interval) clearInterval(interval)
      setNotifications([])
    }
  }

  function cleanUp() {
    if (interval) clearInterval(interval)
    setNotifications([])
  }

  useEffect(() => {
    if (pollNotificationsEnabled) {
      setUpNotifications()
    }

    return () => {
      cleanUp()
    }
  }, [authentication.isAuthenticated, authentication.accessToken, data])

  const handleMarkAsDelivered = (id: number) => {
    const newNotifications: Notification[] = notifications.map(
      (notification) => {
        if (notification.id === id) {
          return { ...notification, delivered: true }
        }
        return notification
      }
    )

    setNotifications(newNotifications)
    //ToDo: Add BE mutation
    notificationMarkAsDelivered({
      variables: {
        ids: [id]
      }
    })
  }

  const getNotificationType = (notification: Notification) => {
    const notificationType =
      NotificationDisplayType[notification.notificationDisplayType]

    return notificationType === 'Information' ? 'Alert' : notificationType
  }

  const getToastHeaderIcon = (notification: Notification) => {
    let className = ''
    switch (
      NotificationDisplayType[
        notification.notificationDisplayType
      ].toLocaleLowerCase()
    ) {
      case 'success':
        className = 'mdi mdi-check-circle-outline'
        break
      case 'information':
        className = 'mdi mdi mdi-information-outline'
        break
      case 'error':
        className = 'mdi mdi mdi-alert-rhombus-outline'
        break
      default:
        className = 'mdi mdi mdi-information-outline'
    }

    return <span className={className} />
  }

  return (
    <div className='ui-toasts'>
      {notifications.map((notification) => (
        <Toast
          className={NotificationDisplayType[
            notification.notificationDisplayType
          ].toLocaleLowerCase()}
          key={notification.id}
          show={!notification.delivered}
          onClose={() => handleMarkAsDelivered(notification.id)}
          delay={10000}
          autohide
        >
          <Toast.Header>
            {getToastHeaderIcon(notification)}
            <h4 className='me-auto'>{getNotificationType(notification)}</h4>
          </Toast.Header>
          <Toast.Body>{notification.description}</Toast.Body>
        </Toast>
      ))}
    </div>
  )
}

export default ToastNotification
